import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-stream-overview',
  templateUrl: './work-stream-overview.component.html',
  styleUrls: ['./work-stream-overview.component.scss']
})
export class WorkStreamOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
